import { useBrandingContext } from "../../../../../components/BrandingContext";

export const useBranding = () => {
  const { branding, refresh } = useBrandingContext();

  // Keep the same API: fetchBranding triggers a refresh if available
  const fetchBranding = async () => {
    if (refresh) await refresh();
  };

  return {
    fetchBranding,
    branding: branding || { roomNameColor: "#443d80" },
  };
};
